const PrfMonitoring = () => {
  const samplingEventData = [
    {
      "type": "Median Concentration - Base Flow",
      "ct-p1": '5 events',
      "ct-2": '10 events',
    },
    {
      "type": "Median Concentration - Storm Flow",
      "ct-p1": '6 events',
      "ct-2": '6 events',
    },
  ];

  let baseFlowData = [
    {
      "analyte": "TP, µg/L",
      "ct-p1": '47',
      "ct-2": '45',
      "percent_change": '-0.05'
    },
    {
      "analyte": "SRP, µg/L",
      "ct-p1": '11',
      "ct-2": '7',
      "percent_change": '-0.33'
    },
    {
      "analyte": "TDP, µg/L",
      "ct-p1": '19',
      "ct-2": '19',
      "percent_change": '0.03'
    },
    {
      "analyte": "TN, µg/L",
      "ct-p1": '1,025',
      "ct-2": '1,649',
      "percent_change": '0.61'
    },
    {
      "analyte": "NO2+NO3, µg/L",
      "ct-p1": '562',
      "ct-2": '1,072',
      "percent_change": '0.91'
    },
    {
      "analyte": "NH4, µg/L",
      "ct-p1": '70',
      "ct-2": '64',
      "percent_change": '-0.08'
    },
    {
      "analyte": "TSS, mg/L",
      "ct-p1": '13',
      "ct-2": '11',
      "percent_change": '-0.15'
    },
    {
      "analyte": "TVSS, mg/L",
      "ct-p1": '3',
      "ct-2": '3',
      "percent_change": '-0.08'
    }
  ];

  let stormFlowData = [
    {
      "analyte": "TP, µg/L",
      "ct-p1": '343',
      "ct-2": '120',
      "percent_change": '-0.65'
    },
    {
      "analyte": "SRP, µg/L",
      "ct-p1": '24',
      "ct-2": '31',
      "percent_change": '0.33'
    },
    {
      "analyte": "TDP, µg/L",
      "ct-p1": '19',
      "ct-2": '47',
      "percent_change": '1.54'
    },
    {
      "analyte": "TN, µg/L",
      "ct-p1": '2,292',
      "ct-2": '2,038',
      "percent_change": '-0.11'
    },
    {
      "analyte": "NO2+NO3, µg/L",
      "ct-p1": '562',
      "ct-2": '859',
      "percent_change": '0.53'
    },
    {
      "analyte": "NH4, µg/L",
      "ct-p1": '113',
      "ct-2": '126',
      "percent_change": '0.12'
    },
    {
      "analyte": "TSS, mg/L",
      "ct-p1": '209',
      "ct-2": '25',
      "percent_change": '-0.88'
    },
    {
      "analyte": "TVSS, mg/L",
      "ct-p1": '28',
      "ct-2": '7',
      "percent_change": '-0.73'
    }
  ];

  // Declare and configure request overview table
  const samplingEventTable = new requestTable({
    container: "#sampling-event-table",
    filterEnabled: false,
    tableHeaders: {
      'type': 'Event Type',
      'ct-p1': 'CT-P1',
      'ct-2': 'CT-2',
    },
    tableActions: [],
    tableData: samplingEventData,
  });
  samplingEventTable.buildTable();

  baseFlowData = baseFlowData.map((d) => {
    let obj = Object.assign({}, d);
    obj.percent_change = d.percent_change*100;
    return obj;
  });

  stormFlowData = stormFlowData.map((d) => {
    let obj = Object.assign({}, d);
    obj.percent_change = d.percent_change*100;
    return obj;
  });

   // Declare and configure request overview table
   const baseFlowTable = new requestTable({
    container: "#base-flow-table",
    filterEnabled: false,
    tableHeaders: {
      'analyte': 'Analyte',
      'ct-p1': 'CT-P1',
      'ct-2': 'CT-2',
      'percent_change': '% Change',
    },
    tableActions: [],
    tableData: baseFlowData,
  });
  baseFlowTable.buildTable();

  // Declare and configure request overview table
  const stormFlowTable = new requestTable({
    container: "#storm-flow-table",
    filterEnabled: false,
    tableHeaders: {
      'analyte': 'Analyte',
      'ct-p1': 'CT-P1',
      'ct-2': 'CT-2',
      'percent_change': '% Change',
    },
    tableActions: [],
    tableData: stormFlowData,
  });
  stormFlowTable.buildTable();
}; // PrfMonitoring
